import { api } from './api';

export interface Cliente {
  id: number;
  tenantId: number;
  nombre: string;
  email?: string;
  telefono?: string;
  direccion?: string;
  fechaNacimiento?: string;
  isActive: boolean;
  ordenes?: Array<{
    id: number;
    numeroOrden?: string;
    total: number;
    estado: string;
    createdAt: string;
  }>;
  createdAt?: string;
  updatedAt?: string;
}

export interface ClienteCreate {
  nombre: string;
  email?: string;
  telefono?: string;
  direccion?: string;
  fechaNacimiento?: string;
}

export interface ClienteUpdate {
  nombre?: string;
  email?: string;
  telefono?: string;
  direccion?: string;
  fechaNacimiento?: string;
  isActive?: boolean;
}

export interface PaginatedResponse<T> {
  data: {
    [key: string]: T[];
    pagination: {
      total: number;
      page: number;
      limit: number;
      totalPages: number;
    };
  };
}

export const clienteService = {
  getAll: async (
    page = 1,
    limit = 20,
    search?: string
  ): Promise<PaginatedResponse<Cliente>> => {
    const params = new URLSearchParams({
      page: page.toString(),
      limit: limit.toString()
    });
    if (search) params.append('search', search);
    
    const response = await api.get<PaginatedResponse<Cliente>>(`/clientes?${params}`);
    return response.data;
  },

  getById: async (id: number): Promise<{ data: { cliente: Cliente } }> => {
    const response = await api.get<{ data: { cliente: Cliente } }>(`/clientes/${id}`);
    return response.data;
  },

  buscar: async (query: string): Promise<{ data: { clientes: Cliente[] } }> => {
    const response = await api.get<{ data: { clientes: Cliente[] } }>(`/clientes/buscar?q=${encodeURIComponent(query)}`);
    return response.data;
  },

  create: async (data: ClienteCreate): Promise<{ data: { cliente: Cliente } }> => {
    const response = await api.post<{ data: { cliente: Cliente } }>('/clientes', data);
    return response.data;
  },

  update: async (id: number, data: ClienteUpdate): Promise<{ data: { cliente: Cliente } }> => {
    const response = await api.put<{ data: { cliente: Cliente } }>(`/clientes/${id}`, data);
    return response.data;
  },

  delete: async (id: number): Promise<{ message: string }> => {
    const response = await api.delete<{ message: string }>(`/clientes/${id}`);
    return response.data;
  }
};

